import React from "react";
import {connect} from "react-redux";
import ColAtm from "../../../../atomic/Col/Col";
import Container from "@material-ui/core/Container";
import {Animated} from "react-animated-css";
import {PageTitle} from "../../../../atomic/PageHeader/PageTitle";
import RoomList from "./List/RoomList";

import {
    PropertyRoomAndRateList,
    PropertyRoomTypes
} from "../../../../../redux/actions/propertyRoomAndRateActions";
import {RoomPhotoListGet} from "../../../../../redux/actions/Content/Room/roomPhotoAction"
import AllRoomTypes from "./Filters/AllRoomTypes";
import PageHeaderAtm from "../../../../atomic/PageHeader/PageHeader";
import RoomMenu from "../../../Global/Layout/Header/Submenu/Room";
import {Link} from "react-router-dom";
import FooterAtm from "../../../../atomic/Footer/Footer";
import Loading from "../../../../molecules/Loading/Loading";

import {compose} from "redux";
import {withTranslation} from "react-i18next";
import {history} from "../../../../../utils/history";
import {CONTENT, CONTENT_PLACES, CONTENT_ROOM_AMENITIES} from "../../../../../constants/appUrls.constants";
import {Grid} from "@material-ui/core";
let t=null;

class RoomPhotos extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            redirect: false,
            showSuccessHeader: false,
            selectedRoomTypeId : 0,
            selectedRoomRateId : 0,
            roomAddModalStatus : false,
        };
        t = props.t;
    }

    onChangeRoomFilter = (selectedIndex) => {
        this.setState({
            selectedRoomTypeId : selectedIndex,
        });
    };

    componentDidMount() {
        this.props.PropertyRoomAndRateList();
        this.props.PropertyRoomTypes();
    }

    getRoomPhotoList = (roomId) => {
        this.props.RoomPhotoListGet(roomId);
    }

    onClickNextButton = () => {
        this.setState({
            redirect: true,
            showSuccessHeader:true
        })

    };

    headerStatusShow = () =>{
        return  <PageHeaderAtm backButton={CONTENT}
                               exitText={ t('btn-dashboard') }
                               text={ t('enw-room-title') }
                               showSuccessHeader={this.state.showSuccessHeader}
        />
    };

    renderRedirect = () => {
        if (this.state.redirect) {
           /* setTimeout(() => {
                history.push(CONTENT)
            }, 2000);*/
            history.push(CONTENT_PLACES)
        }
    }

    render() {
        return (
            <>
                <PageTitle title={ t('enw-room-room-photos-page_title') } />
                {
                    this.headerStatusShow()
                }
                <RoomMenu roomPhotosColClass="active-menu-bg" />
                <Animated animationIn="bounceInRight" animationInDuration={1000} isVisible={true}>
                    <Container maxWidth="xl">
                        <div className="container-width">
                            <Grid container spacing={2} className="photoButtons room-rate-filter-group">
                                <Grid item className="type-plan-buttons">
                                    { this.props.propertyRoomTypesFetching ? (

                                        <Loading />

                                    ) : (
                                        <AllRoomTypes propertyRoomTypes={this.props.propertyRoomTypes }
                                                      onChangeRoomFilter={this.onChangeRoomFilter}
                                        />
                                    )}

                                </Grid>
                            </Grid>
                            <ColAtm className="room-rate-list-col">
                                { !this.props.propertyRoomRateListFetching &&
                                <RoomList rooms={this.props.propertyRoomRateList}
                                          selectedRoomTypeId={this.state.selectedRoomTypeId}
                                          getRoomPhotoList={this.getRoomPhotoList}
                                          roomPhotoList={this.props.roomPhotoList}
                                          roomPhotoListFetching={this.props.roomPhotoListFetching}
                                />
                                }
                            </ColAtm>
                        </div>
                    </Container>
                </Animated>
                <FooterAtm
                    buttonBackText={ t('btn-back') }
                    iconRightClassName="fas fa-arrow-right"
                    buttonBackStyle={{
                        fontSize: '16px',
                        fontWeight: 'bold',
                        textTransform: 'none',
                    }}
                    buttonNextStyle={{
                        fontSize: '16px',
                        fontWeight: 'bold',
                        textTransform: 'none',
                    }}
                    backTo={CONTENT_ROOM_AMENITIES}
                    component={Link}
                    nextComponent={Link}
                    buttonNextText={ t('btn-next') }
                    iconLeftClassName="fas fa-arrow-left"
                    backDisabled={this.state.showSuccessHeader}
                    nextDisabled={this.state.showSuccessHeader}
                    onClick={this.onClickNextButton}
                />
                {this.renderRedirect()}
            </>
        )
    }
}
const mapStateToProps = (state) => {

    return{
        propertyRoomRateListFetching : state.propertyRoomAndRateReducers.propertyRoomRateListFetching,
        propertyRoomRateList : state.propertyRoomAndRateReducers.propertyRoomRateList,

        propertyRoomTypesFetching : state.propertyRoomAndRateReducers.propertyRoomTypesFetching,
        propertyRoomTypes : state.propertyRoomAndRateReducers.propertyRoomTypes,

        roomPhotoList : state.roomPhotoReducer.roomPhotoList,
        roomPhotoListFetching : state.roomPhotoReducer.fetching
    }
};

const mapDispatchToProps = {
    PropertyRoomAndRateList,
    PropertyRoomTypes,
    RoomPhotoListGet
};

export default compose(withTranslation('common')) (connect(mapStateToProps, mapDispatchToProps )(RoomPhotos));
